import { render } from "./ClienteDetalhe.vue?vue&type=template&id=02074db3&scoped=true"
import script from "./ClienteDetalhe.vue?vue&type=script&lang=js"
export * from "./ClienteDetalhe.vue?vue&type=script&lang=js"

import "./ClienteDetalhe.vue?vue&type=style&index=0&id=02074db3&scoped=true&lang=scss"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02074db3"]])

export default __exports__